import React, { useState, useEffect, useCallback } from "react";
import HeaderSales from "../common/HeaderSales";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import * as Constants from "../Constants/index";
import swal from "sweetalert";
import ResponsivePagination from "react-responsive-pagination";
import { saveAs } from "file-saver";
import Oval from "../../loader/CircleLoade";
import { useFormik } from "formik";
export default function NewEnrollmentReport() {
  // const currentMonth = moment().startOf('month');
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [results, setResults] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchRecord, setSearchRecord] = useState();
  const [limit] = useState("10");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [phoneNum, setPhoneNum] = useState("");
  const [filterData, setFilterData] = useState([]);

  // const dateString = fromDate;
  const formattedDate = moment(fromDate).format("YYYY-MM-DD HH:mm:ss");
  // const dateString2 = toDate;
  const formattedDate2 = moment(toDate).format("YYYY-MM-DD 23:59:59");
  const start = formattedDate.replace(/:/g, "%3A");
  const end = formattedDate2.replace(/:/g, "%3A");

  useEffect(() => {
    getEnrollmentData(
      {
        mobile: "",
        startDate: "",
        endDate: "",
      },
      1
    );
  }, []);

  const searchFormik = useFormik({
    initialValues: {
      mobile: "",
      startDate: "",
      endDate: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.mobile) {
        if (data.mobile.length < 10) {
          errors.mobile = "Mobile must be in 10 digits.";
        }
      }
      if (data.startDate === "" && data.endDate !== "") {
        errors.startDate = "Please select date";
      }
      if (data.startDate !== "" && data.endDate === "") {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "Please select date";
      }
      if (data.startDate && data.endDate && data.startDate > data.endDate) {
        errors.endDate = "End date should be greater than start date";
      }
      // if (data.startDate && data.endDate) {
      //     const maxEndDate = new Date(data.startDate)
      //     maxEndDate.setDate(maxEndDate.getDate() + 30) // Adjust the range as needed (e.g., 31 days)

      //     if (data.endDate > maxEndDate) {
      //         errors.endDate = 'End date should be within 31 days from the start date.'
      //     }
      // }
      return errors;
    },
    onSubmit: (data) => {
      setCurrentPage(1);
      getEnrollmentData(data, 1);
      setFilterData(data);
    },
  });

  const getEnrollmentData = async (data, pageNum) => {
    let token = localStorage.getItem("token");
    const userTypeData = localStorage.getItem("user_type");
    const searchName =
      data?.name !== undefined && data?.name !== ""
        ? `&name=${data?.name}`
        : "";
    const searchMobile =
      data?.mobile !== undefined && data?.mobile !== ""
        ? `&mobile=${data?.mobile}`
        : "";

    let stDate;
    let endDate;

    var momentObj1 = moment(data.startDate);
    var momentObj2 = moment(data.endDate);
    if (data.startDate && data.endDate) {
      var startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
      var startFormattedDate4 = momentObj2.format("YYYY-MM-DD 23:59:59");
      stDate = `&start=${startFormattedDate}`;
      endDate = `&end=${startFormattedDate4}`;
    } else {
      stDate = "";
      endDate = "";
    }
    try {
      setLoading(true);
      await axios
        .get(
          `${Constants.baseUrl}reports/userReport/list?userType=MEMBER${searchMobile}${stDate}${endDate}&sortBy=name&sortAsc=true&limit=${limit}&page=${pageNum}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": localStorage.getItem("langauge"),
              appVersion: Constants.av,
              platform: Constants.pt,
              company: Constants.company,
              program: Constants.program,
            },
          }
        )
        .then((res) => {
          if (res.status === 201) {
            if (res.data.code === 10001 && res.data.output) {
              setResults(res.data.output.results);
              setTotalPages(res.data.output.totalPages);
                setSearchRecord();
            //   console.log(
            //     "res.data.output.results....",
            //     res.data.output.results
            //   );
              setLoading(false);
            } else if (res.data.code === 12002 && res.data.output) {
              setLoading(false);
              setTotalPages(0);
              setSearchRecord(res.data.output.results);
            } else {
              swal({
                text: res.data.msg,
                icon: "error",
                timer: 2000,
                buttons: false,
              });
            }
          } else {
            swal({
              text: res.data.msg,
              icon: "error",
              timer: 2000,
              buttons: false,
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  const download = (data) => {
  let token = localStorage.getItem("token");
  
    let stDate;
    let endDate;
  
  // Handle search parameters
  const searchMobile = data?.mobile ? `&mobile=${data.mobile}` : "";
  const searchName = data?.name ? `&name=${data.name}` : "";
  
  // Handle date parameters
  let dateParams = "";
    var momentObj1 = moment(data.startDate);
    var momentObj2 = moment(data.endDate);
    if (data.startDate && data.endDate) {
      var startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
      var startFormattedDate4 = momentObj2.format("YYYY-MM-DD 23:59:59");
      stDate = `&start=${startFormattedDate}`;
      endDate = `&end=${startFormattedDate4}`;
    } else {
      stDate = "";
      endDate = "";
    }

  try {
    setLoading(true);
    axios
      .get(
        `${Constants.baseUrl}reports/download/usersReportNew?userType=MEMBER${searchMobile}${searchName}${stDate}${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          const fileData = new Blob([res.data], { type: "text/csv" });
          saveAs(fileData, "enrollmentReport.csv");
        } else {
          swal({
            text: res.data.msg || "Failed to download report",
            timer: 2000,
            buttons: false,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Download error:", error);
        swal({
          text: "Failed to download report",
          timer: 2000,
          buttons: false,
        });
      });
  } catch (error) {
    setLoading(false);
    console.error("Download error:", error);
  }
};

const resetHandle = useCallback(() => {
  // Reset the formik form
  searchFormik.resetForm();
  
  // Reset the date states
  setFromDate("");
  setToDate("");
  
  // Reset the results to initial state by fetching fresh data
  getEnrollmentData(
    {
      mobile: "",
      startDate: "",
      endDate: "",
    },
    1
  );
  
  // Reset other states
  setSearchRecord(null);
  setCurrentPage(1);
  setFilterData([]);
  setErrors({});
  setPhoneNum("");
}, [searchFormik]);


  return (
    <>
      {loading ? <Oval /> : null}
      <HeaderSales />
      <section className="blog-area pt182">
        <div className="container">
          <div className="row">
            <div className="col-md-12 tab mb-20">
              <ul className="nav nav-tabs" role="tablist">
                <li role="presentation" className="active">
                  <Link to="#Section1" role="tab" data-toggle="tab">
                    Enrollment Report
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="all-single-blog rpt">
                <form onSubmit={searchFormik.handleSubmit}>
                  <div className="row clearfix mb-15">
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="form-group has-float-label style-two">
                        <label>Mobile No. </label>
                        <input
                          class="form-control reset"
                          type="text"
                          placeholder="Mobile No."
                          id="mobile"
                          value={searchFormik.values.mobile}
                          onChange={(e) => {
                            const numericValue = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 10);
                            searchFormik.handleChange({
                              target: {
                                name: "mobile",
                                value: numericValue,
                              },
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="form-group has-float-label style-two">
                        <label>From Date </label>
                        <div></div>
                        <DatePicker
                          id="startDate"
                          selected={
                            searchFormik.values.startDate
                              ? new Date(searchFormik.values.startDate)
                              : null
                          }
                          onChange={(date) =>
                            searchFormik.setFieldValue("startDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                        />
                      </div>
                      {errors.fromDate && (
                        <div className="error-message">{errors.fromDate}</div>
                      )}
                    </div>
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="form-group has-float-label style-two">
                        <label>To Date </label>
                        <DatePicker
                          id="endDate"
                          selected={
                            searchFormik.values.endDate
                              ? new Date(searchFormik.values.endDate)
                              : null
                          }
                          onChange={(date) =>
                            searchFormik.setFieldValue("endDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                        />
                      </div>
                      {errors.toDate && (
                        <div className="error-message">{errors.toDate}</div>
                      )}
                    </div>
                    <div className="col-md-3 col-sm-12 col-xs-12 text-center">
                      <div className="form-group has-float-label style-two">
                        <label className="invisible" style={{ width: "100%" }}>
                          hidden
                        </label>
                        <button type="submit" className="btn login_btn">
                          Search
                        </button>

                        <button type="reset" className="btn login_btn" style={{marginLeft:"10px"}} onClick={resetHandle} >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="row">
                  <div className="col-md-12">
                    <div className="carrd1">
                      <div className="card-header card-header-warning">
                        <h4 className="card-title">
                          {" "}
                          Enrollment Report
                          {searchRecord === null ? (
                            ""
                          ) : (
                            <Link
                              to="#"
                              class="pull-right"
                              onClick={() => download(searchFormik.values)}
                            >
                              <i class="fa fa-file-excel-o"></i> Export
                            </Link>
                          )}
                        </h4>
                      </div>

                      <div className="card-body table-responsive">
                        <table className="table table-striped mb_01" id="table-to-xls">
                        <thead>
                            <tr>
                            <th>S.No</th>
                            <th>ZonalHead</th>
                            <th>StateHead</th>
                            <th>SalesTeamName</th>
                            <th>Sales Email</th>
                            <th>PlumberName</th>
                            <th>MobileNumber</th>
                            <th>User ID</th>
                            <th>Email ID</th>
                            <th>ID Type</th>
                            <th>ID Number</th>
                            <th>IDFrontImage</th>
                            <th>IDBackImage</th>
                            <th>Address1</th>
                            <th>Address2</th>
                            <th>Address3</th>
                            <th>City</th>
                            <th>District</th>
                            <th>State</th>
                            <th>Date Of Registration</th>
                            <th>RegisterType</th>
                            <th>Status</th>
                            <th>Rejection Reason</th>
                            <th>Admin Name</th>
                            <th>AdminApprovalDate</th>
                            <th>ApprovedBy</th>
                            <th>sales Approval Date</th>
                            <th>Total Earned Points</th>
                            <th>Total Redeemed Points</th>
                            <th>Balance Points</th>
                            <th>FirstScan Date</th>
                            <th>AadharNumber</th>
                            <th>Mobile Number Linked With Aadhar</th>
                            <th>Aadhar Front Image</th>
                            <th>Aadhar Back Image</th>
                            <th>Image Click By Sales Team</th>
                            <th>blockedReason</th>
                            <th>Active/Inactive</th>
                            <th>Blocked/Unblocked</th>
                            </tr>
                        </thead>
                        {searchRecord === null ? (
                            <tbody>
                            <tr>
                                <td colSpan="33" style={{ textAlign: "center", fontSize: "16px" }}>
                                No record found!
                                </td>
                            </tr>
                            </tbody>
                        ) : (
                            <tbody>
                            {results &&
                                results.map((item, index) => {
                                const serialNumber = (currentPage - 1) * limit + index + 1;
                                return (
                                    <tr key={index}>
                                    <td>{serialNumber}</td>
                                    <td>{item[0] || "N/A"}</td> {/* Deepak Kumar */}
                                    <td>{item[1] || "N/A"}</td> {/* ADMIN */}
                                    <td>{item[2] || "N/A"}</td> {/* Anamika nair */}
                                    <td>{item[37] || "N/A"}</td>
                                    <td>{item[3] || "N/A"}</td>
                                    <td>{item[4] || "N/A"}</td> {/* 898582 */}
                                    <td>{item[5] || "N/A"}</td> 
                                    <td>{item[6] || "N/A"}</td> 
                                    <td>{item[7] || "N/A"}</td> 
                                    <td>{item[8] || "N/A"}</td> 
                                    <td>
                                        {item[9] && item[9] !== "" ? (
                                        <Link  target="_blank" to={item[9]} className="select">View</Link>
                                        ) : "N/A"}
                                    </td> {/* Aadhar Front Image */}
                                    <td>
                                        {item[10] && item[10] !== "" ? (
                                        <Link  target="_blank" to={item[10]} className="select">View</Link>
                                        ) : "N/A"}
                                    </td> {/* Aadhar Back Image */}
                                    {/* <td>{item[10] || "N/A"}</td> string */}
                                    <td>{item[11] || "N/A"}</td> {/* '898582' */}
                                    <td>{item[12] || "N/A"}</td> {/* '898582' */}
                                    <td>{item[13] || "N/A"}</td> {/* '898582' */}
                                    <td>{item[14] || "N/A"}</td> {/* string */}
                                    <td>{item[15] || "N/A"}</td> {/* string */}
                                    <td>{item[16] || "N/A"}</td> {/* 2023-11-08 */}
                                    <td>{item[17] || "N/A"}</td> {/* SELF */}
                                    <td>{item[18] || "N/A"}</td> {/* NEW */}
                                    <td>{item[19] || "N/A"}</td> {/* "" */}
                                    <td>{item[20] || "N/A"}</td> {/* "" */}
                                    <td>{item[21] || "N/A"}</td> {/* null */}
                                    <td>{item[22] || "N/A"}</td> {/* "" */}
                                    <td>{item[23] || "N/A"}</td> {/* null */}
                                    <td>{item[24] || "N/A"}</td> {/* 0 */}
                                    <td>{item[25] || "N/A"}</td> {/* 0 */}
                                    <td>{item[26] || "N/A"}</td> {/* 0 */}
                                    <td>{item[27] || "N/A"}</td> {/* null */}
                                    <td>{item[28] || "N/A"}</td> {/* 45998 */}
                                    <td>{item[29] || "N/A"}</td> {/* 558285 */}
                                    <td>
                                       {item[30] || "N/A"}
                                    </td> {/* Aadhar Front Image */}
                                    <td>
                                        {item[31] && item[31] != "" ? (
                                            <Link target="_blank" to={item[31]}>View</Link>
                                        ) : "N/A"}
                                    </td>
                                    <td> {item[32] && item[32] != "" ? (
                                            <Link target="_blank" to={item[32]} className="select">View</Link>
                                        ) : "N/A"}</td> {/* false */}
                                     <td>{item[33] ? "True" : "False"}</td> 
                                    <td>{item[34] || "N/A"}</td>
                                    <td>{item[35] || "N/A"}</td>
                                    <td>{item[36] || "N/A"}</td>
                                    </tr>
                                );
                                })}
                            </tbody>
                        )}
                        </table>
                        {totalPages > 1 && (
                          <ResponsivePagination
                            current={currentPage}
                            total={totalPages}
                            onPageChange={(page) => {
                              setCurrentPage(page);
                              getEnrollmentData(filterData, page);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
